module.exports = __webpack_public_path__ + "img/history.8d48c444.svg";